import { render, staticRenderFns } from "./YearHeader.vue?vue&type=template&id=163e366c"
import script from "./YearHeader.vue?vue&type=script&lang=js"
export * from "./YearHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports